import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';
const negativePoints = ['Sin sistema para detectar señales de salud mental en la consulta de rutina: las pasás por alto sin darte cuenta', 'No sabés con certeza cuándo tenés suficiente para denunciar abuso y cuándo no', 'Sin protocolo de denuncia obligatoria: el miedo te paraliza y el menor queda desprotegido', 'Sin scripts para hablar con los padres: cada conversación difícil es una improvización', 'Sin saber cuándo derivar ni cómo documentarlo: si algo sale mal, tu historia clínica no te protege', 'Sin herramientas de screening rápido: la señal de salud mental pasa desapercibida en una consulta de 15 minutos', 'Documentación incompleta en casos con señales de salud mental = exposición legal máxima', 'Sin sistema de coordinación con escuela y juzgado: esas gestiones te consumen el doble del tiempo'];
const positivePoints = ['Sistema claro para detectar señales de salud mental en la consulta de rutina: evaluás con seguridad y precisión.', 'Sabés exactamente qué indicadores buscar y cuándo tenés elementos suficientes para actuar ante sospecha de abuso.', 'Protocolo claro de denuncia obligatoria: actuás con seguridad, protegiendo al menor y a tu matrícula.', 'Scripts probados para hablar con los padres: manejás conversaciones difíciles sobre TDAH, TEA o abuso con autoridad.', 'Criterios claros de derivación y plantillas para documentarla: tu historia clínica demuestra que actuaste correctamente.', 'Herramientas de screening rápido: detectás señales clave incluso en consultas breves de 15 minutos.', 'Documentación completa y blindada: plantillas legales específicas que minimizan tu exposición ante cualquier eventualidad.', 'Sistema eficiente de coordinación con escuela y juzgado: gestionás informes formales rápidamente y sin fricciones.'];
export function Comparison() {
  const [activeTab, setActiveTab] = useState<'sin' | 'con'>('sin');
  return <section className="bg-slate-100 py-8 sm:py-28" data-id="element-63">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8" data-id="element-64">
        <div className="text-center mb-5 sm:mb-12" data-id="element-65">
          <h2 className="text-[10px] sm:text-sm font-semibold tracking-wide text-slate-500 uppercase mb-1.5 sm:mb-3" data-id="element-66">
            LA REALIDAD
          </h2>
          <p className="text-xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-id="element-67">
            ¿Cuánto cuesta NO tenerlo?
          </p>
        </div>

        <div className="bg-white rounded-2xl sm:rounded-3xl shadow-sm ring-1 ring-slate-200 overflow-hidden" data-id="element-68">
          <div className="flex flex-row border-b border-slate-200" data-id="element-69">
            <button onClick={() => setActiveTab('sin')} className={`flex-1 py-2.5 px-2 sm:py-4 sm:px-6 text-center text-xs sm:text-lg font-semibold transition-colors ${activeTab === 'sin' ? 'bg-red-50 text-red-700 border-b-2 border-red-500' : 'text-slate-500 hover:bg-slate-50'}`} data-id="element-70">
              ❌ Sin Megapack
            </button>
            <button onClick={() => setActiveTab('con')} className={`flex-1 py-2.5 px-2 sm:py-4 sm:px-6 text-center text-xs sm:text-lg font-semibold transition-colors ${activeTab === 'con' ? 'bg-teal-50 text-teal-700 border-b-2 border-teal-500' : 'text-slate-500 hover:bg-slate-50'}`} data-id="element-71">
              ✅ Con Megapack
            </button>
          </div>

          <div className="p-2 sm:p-4 text-center bg-slate-50 border-b border-slate-100 text-[10px] sm:text-sm text-slate-500" data-id="element-72">
            Tocá las pestañas para comparar
          </div>

          <div className="p-4 sm:p-8 min-h-[280px] sm:min-h-[400px]" data-id="element-73">
            <AnimatePresence mode="wait" data-id="element-74">
              {activeTab === 'sin' ? <motion.div key="sin" initial={{
              opacity: 0,
              x: -20
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: 20
            }} transition={{
              duration: 0.3
            }} className="space-y-3 sm:space-y-4" data-id="element-75">
                  {negativePoints.map((point, idx) => <div key={idx} className="flex gap-2 sm:gap-4 items-start" data-id="element-76">
                      <XCircle className="w-4 h-4 sm:w-6 sm:h-6 text-red-400 flex-shrink-0 mt-0.5" data-id="element-77" />
                      <p className="text-xs sm:text-base text-slate-700 leading-relaxed" data-id="element-78">
                        {point}
                      </p>
                    </div>)}
                </motion.div> : <motion.div key="con" initial={{
              opacity: 0,
              x: 20
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -20
            }} transition={{
              duration: 0.3
            }} className="space-y-3 sm:space-y-4" data-id="element-79">
                  {positivePoints.map((point, idx) => <div key={idx} className="flex gap-2 sm:gap-4 items-start" data-id="element-80">
                      <CheckCircle2 className="w-4 h-4 sm:w-6 sm:h-6 text-teal-500 flex-shrink-0 mt-0.5" data-id="element-81" />
                      <p className="text-xs sm:text-base text-slate-700 leading-relaxed font-medium" data-id="element-82">
                        {point}
                      </p>
                    </div>)}
                </motion.div>}
            </AnimatePresence>
          </div>
        </div>
      </div>
    </section>;
}